import React from 'react'

const VideoPlayer = ({
  assetUrl,
  setShowVideoPrev,
  mouseOverPreview,
  setMouseOverPreview,
  idx,
}) => {
  const iframeRef = React.useRef(null)
  const ytVideoId = assetUrl.split('=')
  const ytVideoURL = `https://www.youtube.com/embed/${ytVideoId[1]}?rel=0&amp;autoplay=1&mute=1&controls=0&autohide=1&showinfo=0&modestbranding=1&enablejsapi=1`
  const [ytvUrl, setvideoUrl] = React.useState('')
  const previewStartTime = (order) => (order === 0 ? 1500 : order * 9800)

  React.useEffect(() => {
    let fadeInTimer
    let fadeOutTimer
    let loadListener

    if (iframeRef.current) {
      const iframe = iframeRef.current

      loadListener = () => {
        fadeOutTimer = setTimeout(() => {
          setShowVideoPrev(true)
        }, 1300)

        fadeInTimer = setTimeout(() => {
          setShowVideoPrev(false)
        }, 6000)
      }
      iframe.addEventListener('load', loadListener, { passive: true })
    }
    return () => {
      clearTimeout(fadeInTimer)
      clearTimeout(fadeOutTimer)
      if (iframeRef.current && loadListener) {
        iframeRef.current.removeEventListener('load', loadListener, {
          passive: true,
        })
      }
    }
  }, [])

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setvideoUrl(ytVideoURL)
    }, previewStartTime(idx))
    return () => clearTimeout(timer)
  }, [])

  React.useEffect(() => {
    if (mouseOverPreview) {
      setShowVideoPrev(true)
      // Play the video when mouse enters
      if (iframeRef.current) {
        iframeRef.current.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*',
        )
      }
      setTimeout(() => {
        setShowVideoPrev(false)
        setMouseOverPreview(false)
        // Pause the video when mouse leaves after timeout
        if (iframeRef.current) {
          iframeRef.current.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*',
          )
        }
      }, 3000)
    }
  }, [mouseOverPreview])

  return (
    <div
      onMouseEnter={() => {
        // Play video on mouse enter
        if (iframeRef.current) {
          iframeRef.current.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*',
          )
        }
      }}
      onMouseLeave={() => {
        // Pause video on mouse leave
        if (iframeRef.current) {
          iframeRef.current.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*',
          )
        }
      }}
    >
      <iframe
        allow=""
        style={{ pointerEvents: 'none' }}
        ref={iframeRef}
        height={180}
        width={350}
        src={ytvUrl}
        allowFullScreen
        title="Embedded youtube"
      />
    </div>
  )
}

export default VideoPlayer
